import { render } from "./Index.vue?vue&type=template&id=24722fb4&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=24722fb4&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=24722fb4&lang=scss"

import exportComponent from "/data/repos/49/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24722fb4"]])

export default __exports__